import MainLayout from '../layouts/main';
import RankingContainer from './container';

function RankingPage() {
  return (
    <MainLayout>
      <RankingContainer />
    </MainLayout>
  );
}

export default RankingPage;
